export default "__VITE_ASSET__DqnTcEKV__"